var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-card-featured-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-8 pt-md-0 pl-md-3 mt-n3 mt-md-0" },
        [
          _vm.isLoading
            ? _c("div", [_c("div", [_c("video-loading-skeleton")], 1)])
            : _c("div", { staticClass: "video-player-wrapper" }, [
                _c("iframe", {
                  attrs: {
                    src: this.videoPreviewUrl,
                    scrolling: "no",
                    allowfullscreen: "",
                    title: this.featuredVideo.Title
                  }
                })
              ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-4 pt-md-0 pl-md-3 mt-md-0" }, [
        _c(
          "div",
          { staticClass: "video-card-body px-0 pt-3 pt-md-0" },
          [
            _c("video-card-details", {
              staticClass: "pb-1 pb-md-0",
              attrs: { date: this.featuredVideo.StartDate }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pt-1",
                on: {
                  click: function($event) {
                    return _vm.navigateToVideoPost()
                  }
                }
              },
              [
                _c("h3", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(this.featuredVideo.Title))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "card-description",
              domProps: {
                innerHTML: _vm._s(
                  "" + this.truncateString(this.featuredVideo.Summary, 250)
                )
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c323544", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c323544","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/campaigns/VideoCardFeatured.vue
// module id = null
// module chunks = 